<template>
  <div style="margin-bottom:150px;">
    <div class="uk-card uk-card-default uk-width-1-1 uk-margin-large-bottom">
      <div class="uk-card-header">
        <div class="uk-grid-small uk-flex-middle" uk-grid>
          <div class="uk-width-auto">
            <img width="50" height="50" src="https://w.namu.la/s/6eb1c248bfe3e65e379895405895de473e87d8c68c8185b564be5d4f305aa3f5674de1fb2559d07988a48105185fd4481dc9f9d948282123cc8f05b563f0f210efcede139ce8f5635c8f7f9cb0e443e874c004963bfc7dbf2ccacf4ef8a28970c0ed37bec4217050a2a7ee14fabaf176" alt="Avatar">
          </div>
          <div class="uk-width-expand">
            <h3 class="uk-margin-remove-bottom">김나영</h3>
          </div>
          <div class="uk-width-auto">
            <div class="uk-text-meta uk-margin-remove-top">회사 : CY | 전화 번호 : 010-9999-9999 | 직급 : 과장 | 직책 : 디자이너</div>
            <div class="uk-text-meta uk-margin-remove-top"><span class="uk-label uk-label-warning">프로젝트 참여 중</span> | <span class="uk-label uk-label-success">45일 뒤 참여 가능</span></div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <ul class="uk-list uk-list-bullet">
          <li> - 병원용 미용/의료기기 펌웨어 개발 및 인증 대응(주 6시간 업무) | 디자인 논의 단계 진행 | 30% <span class="uk-label uk-label-primary">진행 중</span></li>
          <li> - 크라우드 펀딩 앱 Android, iOS 네이티브 개발 | 수주 단계 | 70% <span class="uk-label uk-label-warning">대기</span></li>
        </ul>
      </div>
      <div class="uk-card-footer">
        <a href="/projectdetail" class="uk-button uk-button-text">참여중인 프로젝트 바로가기</a>
      </div>
    </div>
    <div class="uk-card uk-card-default uk-width-1-1 uk-margin-large-bottom">
      <div class="uk-card-header">
        <div class="uk-grid-small uk-flex-middle" uk-grid>
          <div class="uk-width-auto">
            <img width="50" height="50" src="https://img.hankyung.com/photo/202208/03.30909476.1.jpg" alt="Avatar">
          </div>
          <div class="uk-width-expand">
            <h3 class="uk-margin-remove-bottom">김미영</h3>
          </div>
          <div class="uk-width-auto">
            <div class="uk-text-meta uk-margin-remove-top">회사 : 프리랜서 | 전화 번호 : 010-9999-9999 | 직급 : 대리 | 직책 : 백엔드 개발자</div>
            <div class="uk-text-meta uk-margin-remove-top"><span class="uk-label uk-label-warning">프로젝트 참여 중</span> | <span class="uk-label uk-label-success">45일 뒤 참여 가능</span></div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <ul class="uk-list uk-list-bullet">
          <li> - 병원용 미용/의료기기 펌웨어 개발 및 인증 대응(주 6시간 업무) | 디자인 논의 단계 진행 | 30% <span class="uk-label uk-label-primary">진행 중</span></li>
          <li> - 크라우드 펀딩 앱 Android, iOS 네이티브 개발 | 수주 단계 | 70% <span class="uk-label uk-label-warning">대기</span></li>
        </ul>
      </div>
      <div class="uk-card-footer">
        <a href="/projectdetail" class="uk-button uk-button-text">참여중인 프로젝트 바로가기</a>
      </div>
    </div>
    <div class="uk-card uk-card-default uk-width-1-1 uk-margin-large-bottom">
      <div class="uk-card-header">
        <div class="uk-grid-small uk-flex-middle" uk-grid>
          <div class="uk-width-auto">
            <img width="50" height="50" src="http://www.tvj.co.kr/news/photo/202209/74666_206706_4549.jpg" alt="Avatar">
          </div>
          <div class="uk-width-expand">
            <h3 class="uk-margin-remove-bottom">최예슬</h3>
          </div>
          <div class="uk-width-auto">
            <div class="uk-text-meta uk-margin-remove-top">회사 : BSG | 전화 번호 : 010-9999-9999 | 직급 : 과장 | 직책 : 운영</div>
            <div class="uk-text-meta uk-margin-remove-top"><span class="uk-label uk-label-primary">대기</span></div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <ul class="uk-list uk-list-bullet">
          <li> - 병원용 미용/의료기기 펌웨어 개발 및 인증 대응(주 6시간 업무) | 납품 | 100% <span class="uk-label uk-label-primary">완료</span></li>
        </ul>
      </div>
    </div>
    <div class="uk-card uk-card-default uk-width-1-1 uk-margin-large-bottom">
      <div class="uk-card-header">
        <div class="uk-grid-small uk-flex-middle" uk-grid>
          <div class="uk-width-auto">
            <img width="50" height="50" src="https://talkimg.imbc.com/TVianUpload/tvian/TViews/image/2022/07/15/f33aa0ea-c790-4993-98fc-3acb4fdf9936.jpg" alt="Avatar">
          </div>
          <div class="uk-width-expand">
            <h3 class="uk-margin-remove-bottom">박나은</h3>
          </div>
          <div class="uk-width-auto">
            <div class="uk-text-meta uk-margin-remove-top">회사 : CY | 전화 번호 : 010-9999-9999 | 직급 : 과장 | 직책 : 디자이너</div>
            <div class="uk-text-meta uk-margin-remove-top"><span class="uk-label uk-label-warning">프로젝트 참여 중</span> | <span class="uk-label uk-label-success">45일 뒤 참여 가능</span></div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <ul class="uk-list uk-list-bullet">
          <li> - 병원용 미용/의료기기 펌웨어 개발 및 인증 대응(주 6시간 업무) | 디자인 논의 단계 진행 | 30% <span class="uk-label uk-label-primary">진행 중</span></li>
          <li> - 크라우드 펀딩 앱 Android, iOS 네이티브 개발 | 수주 단계 | 70% <span class="uk-label uk-label-warning">대기</span></li>
        </ul>
      </div>
      <div class="uk-card-footer">
        <a href="/projectdetail" class="uk-button uk-button-text">참여중인 프로젝트 바로가기</a>
      </div>
    </div>
    <div class="uk-card uk-card-default uk-width-1-1">
      <div class="uk-card-header">
        <div class="uk-grid-small uk-flex-middle" uk-grid>
          <div class="uk-width-auto">
            <img width="50" height="50" src="https://pbs.twimg.com/media/FRu76vAVsAIpipY.jpg:large" alt="Avatar">
          </div>
          <div class="uk-width-expand">
            <h3 class="uk-margin-remove-bottom">카즈하</h3>
          </div>
          <div class="uk-width-auto">
            <div class="uk-text-meta uk-margin-remove-top">회사 : CY | 전화 번호 : 010-9999-9999 | 직급 : 과장 | 직책 : 디자이너</div>
            <div class="uk-text-meta uk-margin-remove-top"><span class="uk-label uk-label-warning">프로젝트 참여 중</span> | <span class="uk-label uk-label-success">45일 뒤 참여 가능</span></div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <ul class="uk-list uk-list-bullet">
          <li> - 병원용 미용/의료기기 펌웨어 개발 및 인증 대응(주 6시간 업무) | 디자인 논의 단계 진행 | 30% <span class="uk-label uk-label-primary">진행 중</span></li>
          <li> - 크라우드 펀딩 앱 Android, iOS 네이티브 개발 | 수주 단계 | 70% <span class="uk-label uk-label-warning">대기</span></li>
        </ul>
      </div>
      <div class="uk-card-footer">
        <a href="/projectdetail" class="uk-button uk-button-text">참여중인 프로젝트 바로가기</a>
      </div>
    </div>
    <div class="uk-text-center uk-margin-large-top">
      <button class="uk-button uk-button-default uk-button-large" type="button" uk-toggle="target: #modal-overflow">수정</button>
    </div>
    <div id="modal-overflow" class="uk-modal-container" uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-modal-header">
          <h2 class="uk-modal-title">멤버 수정</h2>
        </div>
        <div class="uk-modal-body" uk-overflow-auto>
          <table class="uk-table uk-table-justify uk-table-divider">
            <thead>
              <tr>
                <th class="uk-width-small">이름</th>
                <th>관련 내용</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>김나영</td>
                <td>프론트엔드 개발자 | 과장 | 010-1111-2222 | CY | 31세</td>
                <td><button class="uk-button uk-button-default" type="button">수정</button></td>
              </tr>
              <tr>
                <td>김나영</td>
                <td>프론트엔드 개발자 | 과장 | 010-1111-2222 | CY | 31세</td>
                <td><button class="uk-button uk-button-default" type="button">수정</button></td>
              </tr>
              <tr>
                <td>김나영</td>
                <td>프론트엔드 개발자 | 과장 | 010-1111-2222 | CY | 31세</td>
                <td><button class="uk-button uk-button-default" type="button">수정</button></td>
              </tr>
              <tr>
                <td>김나영</td>
                <td>프론트엔드 개발자 | 과장 | 010-1111-2222 | CY | 31세</td>
                <td><button class="uk-button uk-button-default" type="button">수정</button></td>
              </tr>
              <tr>
                <td>김나영</td>
                <td>프론트엔드 개발자 | 과장 | 010-1111-2222 | CY | 31세</td>
                <td><button class="uk-button uk-button-default" type="button">수정</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>